import { registerDecorator } from 'class-validator';
const VAT_ID_REGEX = /^DE\d{9}$/;
export function normalizeVatId(value) {
    return value.replace(/\s+/g, '').toUpperCase();
}
export function isVatIdValid(value) {
    return VAT_ID_REGEX.test(normalizeVatId(value));
}
export function IsValidVatId(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isValidVatId',
            target: object.constructor,
            propertyName,
            options: { message: 'USt-ID is not valid', ...validationOptions },
            validator: {
                validate(value) {
                    return typeof value === 'string' && isVatIdValid(value);
                },
            },
        });
    };
}
//# sourceMappingURL=vat-id.js.map